import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BatteryCharging, Calendar, Car, ChevronLeft, ChevronRight, DollarSign, MessageCircle, RefreshCw, TrendingUp, Zap } from 'lucide-react';
const WHATSAPP = 'https://wa.me/5491127063704';
const HERO_IMAGE = 'https://cdn.shopify.com/s/files/1/0781/8136/7957/files/rn-image_picker_lib_temp_466207d5-1d6e-4398-92f1-5996d0310b32.jpg?v=1787197407';
const fotos = ['https://cdn.shopify.com/s/files/1/0781/8136/7957/files/rn-image_picker_lib_temp_196aa707-2894-4558-8e32-b50ebd1599fb.jpg?v=1787197408', 'https://cdn.shopify.com/s/files/1/0781/8136/7957/files/rn-image_picker_lib_temp_85faec4b-2e8a-41a4-964e-4f6d7fed249c.jpg?v=1787197408', 'https://cdn.shopify.com/s/files/1/0781/8136/7957/files/rn-image_picker_lib_temp_c120c290-eacb-450d-96cd-a4405581a3dc.jpg?v=1787197720', 'https://cdn.shopify.com/s/files/1/0781/8136/7957/files/rn-image_picker_lib_temp_0b03e731-0066-476a-9df6-eb1049b99c2f.jpg?v=1787197720'];
const pasos = [{
  icon: Calendar,
  title: 'Alquiler semanal',
  lines: [{
    text: '$600.000 por semana',
    tone: 'white' as const
  }, {
    text: 'durante 24 meses',
    tone: 'accent' as const
  }],
  note: 'Abonás $600.000 por semana durante 24 meses.'
}, {
  icon: Car,
  title: 'Al finalizar los 24 meses',
  lines: [{
    text: 'Podés dar el anticipo',
    tone: 'white' as const
  }, {
    text: 'del 50% y el auto',
    tone: 'accent' as const
  }, {
    text: 'pasa a ser tuyo.',
    tone: 'accent' as const
  }]
}, {
  icon: DollarSign,
  title: 'Si no contás con el capital',
  lines: [{
    text: 'Te financiamos, pagando',
    tone: 'white' as const
  }, {
    text: '$1.000.000 por mes',
    tone: 'accent' as const
  }],
  note: 'durante 18 meses más.'
}, {
  icon: RefreshCw,
  title: 'Como dueño del auto',
  lines: [{
    text: 'Tenemos opciones de',
    tone: 'white' as const
  }, {
    text: 'renovación por otro con',
    tone: 'white' as const
  }, {
    text: 'menos kilometraje.',
    tone: 'white' as const
  }]
}];
const ingresos = [{
  icon: Calendar,
  label: 'Alquiler',
  value: '$600.000 por semana / $85.000 por día'
}, {
  icon: Zap,
  label: 'Gasto de carga',
  value: '$5.000 por día'
}, {
  icon: TrendingUp,
  label: 'Ganancia aprox.',
  value: '$200.000 por día (9 a 10hs)'
}, {
  icon: Calendar,
  label: '30 días x $200.000',
  value: '$6.000.000 por mes'
}];
function CarCarousel() {
  const [index, setIndex] = useState(0);
  const go = (next: number) => setIndex((next + fotos.length) % fotos.length);
  return <div data-id="element-265" data-mp="3glhkixf8fr30">
      <div className="relative h-[55vw] min-h-[300px] max-h-[500px] overflow-hidden rounded-xl bg-brand-black" data-id="element-266" data-mp="3gl7sz5ejhbv7">
        <div className="flex h-full transition-transform duration-300 ease-[cubic-bezier(0.23,1,0.32,1)]" style={{
        transform: `translateX(-${index * 100}%)`
      }} data-id="element-267" data-mp="3bjsbtofhfpi3">
          {fotos.map((foto, i) => <img key={i} src={foto} alt={`BAIC Beijing EU5 2026 — foto ${i + 1} de ${fotos.length}`} loading="lazy" className="w-full h-full shrink-0 object-contain object-center bg-brand-black" data-id="element-268" data-mp="1i3eczg5onwwi" data-mpi={i} />)}
        </div>

        <button type="button" onClick={() => go(index - 1)} aria-label="Foto anterior" className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-brand-gold text-brand-black flex items-center justify-center hover:bg-brand-white transition-colors" data-id="element-269" data-mp="1w3ff0yxopadk">
          <ChevronLeft className="w-6 h-6" data-id="element-270" data-mp="18ca1iqf7uu6f" />
        </button>
        <button type="button" onClick={() => go(index + 1)} aria-label="Foto siguiente" className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-brand-gold text-brand-black flex items-center justify-center hover:bg-brand-white transition-colors" data-id="element-271" data-mp="1d41jickb3rky">
          <ChevronRight className="w-6 h-6" data-id="element-272" data-mp="2n9w7326d90mi" />
        </button>
      </div>

      <div className="flex justify-center gap-2 mt-5" data-id="element-273" data-mp="2ibb4iw3n64uw">
        {fotos.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Ver foto ${i + 1}`} aria-current={i === index} className={`h-2 rounded-full transition-all duration-200 ${i === index ? 'w-6 bg-brand-gold' : 'w-2 bg-brand-white/25'}`} data-id="element-274" data-mp="2i9hvxb9gxak9" data-mpi={i} />)}
      </div>

      <p className="text-center text-brand-white font-bold text-lg mt-6" data-id="element-275" data-mp="311ki124vpj1w">
        BAIC Beijing EU5 2026 — 0KM Eléctrico
      </p>
    </div>;
}
export function Electrico() {
  return <section id="electrico" className="bg-brand-black relative" data-id="element-276" data-mp="3b0i31v33iug5">
      {/* 1 — Banner */}
      <div className="relative min-h-[520px] flex items-center" data-id="element-277" data-mp="1koc5wfte2mud">
        <div className="absolute inset-0" data-id="element-278" data-mp="1gmh3f7zq23f0">
          <img src={HERO_IMAGE} alt="BAIC Beijing EU5 eléctrico de Flash & Go" className="w-full h-full object-cover object-center" data-id="element-279" data-mp="1gnjv3i4vc9vz" />
          <div className="absolute inset-0 bg-black/60" data-id="element-280" data-mp="1aikozudumc35"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 py-24 w-full" data-id="element-281" data-mp="wsqzd9uirnsd">
          <span className="inline-flex items-center gap-1.5 bg-brand-gold text-brand-black text-xs font-bold px-3 py-1.5 rounded-full mb-6" data-id="element-282" data-mp="mshwjd60v440">
            <Zap className="w-3.5 h-3.5 fill-brand-black" data-id="element-283" data-mp="dtczyce0tkuh" />
            NUEVO
          </span>

          <h2 className="font-heading text-6xl md:text-7xl lg:text-8xl leading-[0.9] mb-6" data-id="element-284" data-mp="dvpmz3ymylee">
            <span className="text-brand-white block" data-id="element-285" data-mp="iuarhfkx7r8n">TU 0KM ELÉCTRICO</span>
            <span className="text-brand-gold block" data-id="element-286" data-mp="2885t84rflzj9">
              PARA VIAJES CORPORATIVOS
            </span>
          </h2>

          <span className="inline-block border border-brand-white text-brand-white text-sm font-bold px-4 py-2 rounded-full mb-5" data-id="element-287" data-mp="2d44ng8zfybrl">
            HABILITADO POR CABIFY
          </span>

          <p className="text-brand-white/90 text-sm" data-id="element-288" data-mp="26sbjiu0rtitt">
            Somos un concesionario ubicado en CABA, Parque Patricios.
          </p>
        </motion.div>
      </div>

      {/* 2 — Carousel */}
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-20" data-id="element-289" data-mp="1wtvtkudhcflw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-290" data-mp="2uerqhtd7wg1v">
          <CarCarousel data-id="element-291" data-mp="2pj2q5ntdiv4i" />
        </motion.div>
      </div>

      {/* 3 — How it works */}
      <div className="max-w-7xl mx-auto px-5 sm:px-6 pb-20" data-id="element-292" data-mp="2knx3gms5dcfd">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-293" data-mp="2fpvj7yizj72b">
          <h3 className="font-heading text-5xl md:text-6xl text-brand-white mb-3" data-id="element-294" data-mp="38ejb4cy8ouou">
            ¿Cómo funciona?
          </h3>
          <p className="text-xl text-brand-gold" data-id="element-295" data-mp="3fsjw1gb2qm0s">4 pasos simples</p>
        </motion.div>

        <div className="relative" data-id="element-296" data-mp="3kqbz96h65uka">
          {/* Connecting line */}
          <div aria-hidden="true" className="hidden lg:block absolute top-6 left-[12.5%] right-[12.5%] h-px bg-brand-gold/30" data-id="element-297" data-mp="3pon8pg3jy31z"></div>

          <ol className="grid gap-10 lg:grid-cols-4 lg:gap-6" data-id="element-298" data-mp="2k72q6pvqjfz">
            {pasos.map((paso, i) => {
            const Icon = paso.icon;
            return <motion.li key={paso.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.08
            }} className="relative flex lg:flex-col gap-5 lg:gap-0 lg:text-center" data-id="element-299" data-mp="7hpavuw2oumx" data-mpi={i}>
                  <div className="relative z-10 shrink-0 w-12 h-12 rounded-full bg-brand-gold text-brand-black font-heading text-2xl flex items-center justify-center lg:mx-auto" data-id="element-300" data-mp="q903qhlczhhg">
                    {i + 1}
                  </div>

                  <div className="lg:mt-6" data-id="element-301" data-mp="17ilctslq3kkz">
                    <Icon className="w-6 h-6 text-brand-gold mb-3 lg:mx-auto" data-id="element-302" data-mp="1linubdq4cbzp" />
                    <h4 className="text-brand-white font-bold mb-2" data-id="element-303" data-mp="1lgjq0uob5ayw">
                      {paso.title}
                    </h4>
                    {paso.lines.map(line => <p key={line.text} className={line.tone === 'accent' ? 'text-brand-gold font-bold' : 'text-brand-white'} data-id="element-304" data-mp="sui62gzuw4v4">
                        {line.text}
                      </p>)}
                    {paso.note && <p className="text-brand-white/45 text-[13px] mt-2" data-id="element-305" data-mp="54nue2r9wmcg">
                        {paso.note}
                      </p>}
                  </div>
                </motion.li>;
          })}
          </ol>
        </div>
      </div>

      {/* 4 — Calculator */}
      <div className="max-w-7xl mx-auto px-5 sm:px-6 pb-32" data-id="element-306" data-mp="27rbaq8eqag0z">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#111] border border-brand-gold/40 rounded-2xl p-6 sm:p-10" data-id="element-307" data-mp="27t60q14uwybx">
          <h3 className="font-heading text-4xl md:text-5xl text-brand-white mb-10" data-id="element-308" data-mp="34hbz46b6quhr">
            Rentabilidad aproximada mensual
          </h3>

          <div className="grid lg:grid-cols-2 gap-8" data-id="element-309" data-mp="2qh17h121xbvj">
            {/* Income */}
            <div className="space-y-3" data-id="element-310" data-mp="2vg4akfyh180v">
              {ingresos.map(row => {
              const Icon = row.icon;
              return <div key={row.label} className="flex items-start gap-4 bg-[#1A1A1A] rounded-xl p-4" data-id="element-311" data-mp="1f4qo1l976s3r">
                    <div className="shrink-0 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-312" data-mp="27hcepdvsr5l8">
                      <Icon className="w-5 h-5 text-brand-gold" data-id="element-313" data-mp="2bguz88jphenj" />
                    </div>
                    <div className="min-w-0" data-id="element-314" data-mp="1xpq6lqer9mmp">
                      <p className="text-brand-white font-bold text-sm" data-id="element-315" data-mp="22p2t2a1psror">
                        {row.label}
                      </p>
                      <p className="text-brand-white/60 text-[13px] mt-0.5" data-id="element-316" data-mp="1nr0rg5e8uga5">
                        {row.value}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            {/* Expenses and net */}
            <div className="bg-brand-black border border-brand-gold/40 rounded-xl p-6 flex flex-col" data-id="element-317" data-mp="1jpynxcdani2d">
              <h4 className="font-heading text-2xl text-brand-gold mb-5" data-id="element-318" data-mp="394v8wtaz5j5s">
                RESTAMOS GASTOS
              </h4>

              <ul className="space-y-3 mb-8" data-id="element-319" data-mp="3e36ntig4mjuv">
                <li className="flex items-start gap-3 text-brand-white/80 text-sm" data-id="element-320" data-mp="3o8fz4gn4741i">
                  <BatteryCharging className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-321" data-mp="3o6btnu9khwz4" />
                  Gasto de carga $5.000 x 30 días = $150.000
                </li>
                <li className="flex items-start gap-3 text-brand-white/80 text-sm" data-id="element-322" data-mp="wx40opxghpr">
                  <Calendar className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-323" data-mp="3s8yrcbsx6c48" />
                  Semana x 4: $600.000 x 4 = $2.400.000
                </li>
              </ul>

              <div className="mt-auto bg-brand-gold text-brand-black rounded-xl p-6 text-center" data-id="element-324" data-mp="5uynvbv6gl2a">
                <p className="text-xs font-bold mb-3 opacity-80" data-id="element-325" data-mp="juq65osq8nm3">
                  TOTAL: $6.000.000 - $2.400.000 - $150.000
                </p>
                <p className="font-heading text-6xl leading-none" data-id="element-326" data-mp="ftee7cmdrqaq">$3.450.000</p>
                <p className="font-bold text-sm mt-3" data-id="element-327" data-mp="2lmcpd46dne80">
                  GANANCIA NETA APROXIMADA POR MES
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 text-center" data-id="element-328" data-mp="kk55d3kh4k6w">
            <a href={`${WHATSAPP}?text=${encodeURIComponent('Hola! Me interesa el programa de alquiler del BAIC Beijing EU5 eléctrico. ¿Me pasás más información?')}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-329" data-mp="kl6kbj4m1qtw">
              <MessageCircle className="w-5 h-5" data-id="element-330" data-mp="18h14d0t3nq04" />
              QUIERO MI 0KM ELÉCTRICO
            </a>
          </div>
        </motion.div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-331" data-mp="1dadey70y1w9v"></div>
    </section>;
}